import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";

import { EventTypes } from "@/types/events";

import { useForceRerender } from "shared/hooks";

export interface PortalProps {
  children: ReactNode;
  elementId: string;
}

export function Portal({ children, elementId }: PortalProps) {
  const forceRerender = useForceRerender();

  const element = document.getElementById(elementId);

  useEffect(() => {
    const handleForceRerender: EventListener = (_event) => {
      forceRerender();
    };

    document.addEventListener(EventTypes.ReRenderPortals, handleForceRerender);

    return () => {
      document.removeEventListener(
        EventTypes.ReRenderPortals,
        handleForceRerender,
      );
    };
  }, [forceRerender]);

  useEffect(() => {
    setTimeout(() => {
      forceRerender();
    }, 100);
  }, [forceRerender]);

  if (element) {
    return createPortal(children, element);
  }
}
